import { colors } from '@mui/material';

const white = '#FFFFFF';
export const colorPalette = ['#4e5775', '#3859e3', '#37ddf3', '#a9fecc', '#ccf1cd', '#0c4e8c', '#f44336'];

const customColors = {
  primary: '#3859e3'
};

export default {
  type: 'light',
  primary: {
    contrastText: white,
    main: colorPalette[1],
    light: '#DEE3F3'
  },
  secondary: {
    light: colors.grey[100],
    main: colors.grey[100],
    dark: colors.grey[300]
  },
  error: {
    contrastText: white,
    dark: colors.red[900],
    main: colors.red[600],
    light: colors.red[400],
    ultraLight: colors.red[100]
  },
  success: {
    main: '#DEEFE5',
    dark: '#0B7C3D'
  },
  errorStatus: {
    main: '#FAE2E2',
    dark: '#D10E0C'
  },
  primaryStatus: {
    main: '#EAF2FD',
    dark: colorPalette[1]
  },
  warningStatus: {
    main: '#FDEDDE',
    dark: '#DC6700'
  },
  danger: '#EB5757',
  warning: {
    main: '#EB7710',
    light: '#FDEDDE'
  },
  warningAlert: {
    main: '#F2994A',
    contrastText: '#FFFFFF'
  },
  text: {
    primary: '#455775',
    secondary: '#888a91',
    link: colorPalette[1]
  },
  header: {
    default: colorPalette[0],
    primaryColor: colorPalette[1]
  },
  sectionHeader: {
    primary: '#878FA1'
  },
  input: {
    background: '#F6F9FE',
    borderColor: 'rgba(0,0,0,0.15)'
  },
  link: colorPalette[1],
  icon: customColors.primary,
  background: {
    default: '#f5f9ff',
    paper: white
  },
  table: {
    row: {
      selected: {
        backgroundColor: '#f1f4ff'
      }
    }
  },
  colorPalette,
  divider: colors.grey[200],
  gray: {
    dark: '#546e7a',
    main: '#8998AF',
    light: '#CED4DD',
    superLight: '#eee',
    muted: '#959595'
  },
  buttons: {
    success: {
      background: '#6FCF9740',
      color: '#46A06B'
    },
    error: {
      background: '#EB575733',
      color: '#EB5757'
    }
  },
  alerts: {
    error: {
      background: '#FF9999',
      iconBackground: '#FF0000',
      color: '#CA0101',
      iconColor: '#EFB8B8'
    },
    info: {
      background: '#87EBF8',
      iconBackground: '#37c8f1',
      color: '#3859E3',
      iconColor: '#FFF'
    },
    warning: {
      background: '#F8E4A5',
      iconBackground: '#F2C94C',
      color: '#F97501',
      iconColor: '#F2994A'
    }
  },
  transactions: {
    status: {
      completed: '#6FCF97',
      pending: '#95A8ED',
      cancelled: '#B1B1B1',
      declined: '#EB5757'
    },
    category: {
      background: {
        notSupported: '#FAE2E2',
        supported: '#DFEBFA'
      },
      color: {
        notSupported: '#EB5757'
      }
    }
  },
  dataReview: {
    status: {
      reviewed: '#6FCF97',
      notReviewed: '#EB5757'
    }
  },
  flexflowEmployee: {
    status: {
      not_enabled: '#B1B1B1',
      enabled: '#3859E3',
      active: '#6FCF97',
      disabled: '#EB5757',
      blocked: '#0E0E0E'
    }
  },
  flexflowCard: {
    status: {
      notRequested: '#B1B1B1',
      active: '#6FCF97',
      unactivated: '#3859E3',
      terminated: '#0E0E0E',
      suspended: '#95A8ED'
    }
  },
  charts: {
    tooltip: {
      background_hover: '#5672E7'
    },
    colors: ['#5672E7', '#56A8EE', '#55E2F5'],
    line: {
      color: '#5672E7'
    }
  }
};
